import { render, staticRenderFns } from "./HistorySupplierAssignation.vue?vue&type=template&id=794aaacb&scoped=true&"
import script from "./HistorySupplierAssignation.vue?vue&type=script&lang=js&"
export * from "./HistorySupplierAssignation.vue?vue&type=script&lang=js&"
import style0 from "./HistorySupplierAssignation.vue?vue&type=style&index=0&id=794aaacb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794aaacb",
  null
  
)

export default component.exports